import { BaseTooltipProps } from './BaseTooltip.typed';
import * as Styled from './BaseTooltip.styled';
import { Text } from '../../Text/Text';
import withDefaultProps from '../../../hoc/withDefaultProps';

export const BaseTooltip = ({ children, size = 'm' }: BaseTooltipProps) => {
  return <Styled.BaseTooltip size={size}>{children}</Styled.BaseTooltip>;
};

// Define Header and Body components with default props
BaseTooltip.Header = withDefaultProps(Text, {
  as: 'h2',
  size: 'l',
  // TODO: figure out how to apply theme values in this context
  color: '#fff',
  weight: 'bold',
});

BaseTooltip.Body = withDefaultProps(Text, {
  as: 'p',
  size: 'm',
  color: '#fff',
});
